import whitelabelService from "../../../../services/whitelabel/whitelabel.service";
import {
  Container,
  Logo,
  LogoMobileRow,
  LogosWrapper,
  Title,
  TitleWrapper
} from "./Partnership.styles";

export default function Partnership() {
  const whitelabelCompany = whitelabelService.getWBDataCompany();

  return (
    <>
      {whitelabelCompany.partnerLogo && (
        <Container id="clients">
          <TitleWrapper>
            <Title>Parceiro</Title>
          </TitleWrapper>
          <LogosWrapper>
            <LogoMobileRow>
              <Logo src={`images/${whitelabelCompany.partnerLogo}`} />
            </LogoMobileRow>
          </LogosWrapper>
        </Container>
      )}
    </>
  );
};